import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();
const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING;
const instrumentationKey = import.meta.env.VITE_INSTRUMENTATION_KEY;
const appInsights = new ApplicationInsights({
  config: {
    connectionString,
    instrumentationKey,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    disableAjaxTracking: false,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true
  }
});
appInsights.loadAppInsights();

export { reactPlugin, appInsights };
